import { render, staticRenderFns } from "./InsurancesPlanDetailsAdd.vue?vue&type=template&id=5e86f19d&scoped=true&"
import script from "./InsurancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86f19d",
  null
  
)

export default component.exports